import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { warehouseService } from '@services/warehouse';
import { WAREHOUSES_QUERY_KEY } from './useWarehouses';
import { getErrorMessage } from '@utils/errorMessage';
import { useTranslation } from '@hooks/useTranslation';

export const useSetDefaultWarehouse = () => {
  const tActionMessages = useTranslation('actionMessages');
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['warehouse', 'setDefault'],
    mutationFn: async (warehouseId: string) => {
      return await warehouseService.setDefaultWarehouse(warehouseId);
    },
    onSuccess: () => {
      toast.success(tActionMessages.defaultWarehouseUpdatedSuccessfully);
      queryClient.invalidateQueries({ queryKey: WAREHOUSES_QUERY_KEY });
    },
    onError: (error: any) => {
      toast.error(getErrorMessage(error, 'Failed to set default warehouse'));
    },
  });
};

export default useSetDefaultWarehouse;
